module.exports = __webpack_public_path__ + "img/img5.eb5f38ab.svg";